import axios from 'axios'

export const getorganizationData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
    axios.get('/api/organization').then(response=>{
        dispatch({type:'ORGANIZATION_DATA',payload:response.data})
        dispatch({type:'UNLOADING_UI'});
    }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});
 })
}

export const getdepartmentData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
    axios.get('/api/department').then(response=>{
       dispatch({type:'DEPARTMENT_DATA',payload:response.data})
       dispatch({type:'UNLOADING_UI'});
    }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});
    })

}
export const getcontactData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
    axios.get('/api/contact-us').then(response=>{
       dispatch({type:'CONTACT_DATA',payload:response.data})
       dispatch({type:'UNLOADING_UI'});
    }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});
   })
}


export const setorganizationData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
    axios.post('/api/organization',data).then(response=>{
       dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
       dispatch({type:'UNLOADING_UI'});
    }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});
   })
   }
   
export const setdepartmentData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
      axios.post('/api/department',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
         dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
         dispatch({type:'UNLOADING_UI'});
      })
}
   
export const setcontactData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
    axios.post('/api/contact-us',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
         dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
         dispatch({type:'UNLOADING_UI'});
      })
}
export const editTask = (api,data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.put(api+data.id,data).then(response=>{
         dispatch({type:'DEPARTMENT_DATA',payload:response.data})
         dispatch({type:'UNLOADING_UI'});
      }).catch(error=>{
         dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
         dispatch({type:'UNLOADING_UI'});
      })
}
export const deleteTask = (api,data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.delete(api+data.id).then(response=>{
         dispatch({type:'DEPARTMENT_DATA',payload:response.data})
         dispatch({type:'UNLOADING_UI'});
      }).catch(error=>{
         dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
         dispatch({type:'UNLOADING_UI'});
      })
}

// Lab category Api
export const getLabCategoryData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/lab-category').then(response=>{
      dispatch({type:'LABCATEGORY_DATA',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});
   })
}
export const setLabCategoryData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/lab-category',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
         dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
         dispatch({type:'UNLOADING_UI'});
      })
}


// Blooms_Domain Api
export const getBloomsDomainData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/bloom-domain').then(response=>{
      dispatch({type:'BLOOM_DOMAIN_DATA',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});
   })
}
export const setBloomsDomainData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/bloom-domain',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
         dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
         dispatch({type:'UNLOADING_UI'});
      })
}

// Blooms Level Api
export const getBloomsLevelData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/bloom-level').then(response=>{
      dispatch({type:'BLOOM_LEVEL_DATA',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});
   })
}
export const setBloomsLevelData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/bloom-level',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
          dispatch({type:'UNLOADING_UI'});
        })
}

// Delivery Method Api
export const getDeliveryMethodData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/delivery-method').then(response=>{
      dispatch({type:'DELIVERY_METHOD_DATA',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
    })
}
export const setDeliveryMethodData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/delivery-method',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
          dispatch({type:'UNLOADING_UI'});   
          })
}

//Map_Level_Weightage Api
export const getMapLevelWeightageData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/maplevel-weightage').then(response=>{
      dispatch({type:'MAP_LEVEL_WEIGHTAGE',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'});
    })
}
export const setMapLevelWeightageData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/maplevel-weightage',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
          dispatch({type:'UNLOADING_UI'});  
            })
}

//Program_Type
export const getProgramTypeData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/program-type').then(response=>{
      dispatch({type:'PROGRAM_TYPE',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});
     })
}
export const setProgramTypeData= (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/program-type',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
          dispatch({type:'UNLOADING_UI'});    
           })
}

//Program Api
export const getProgramData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/program').then(response=>{
      dispatch({type:'PROGRAM',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
   })
}
export const setProgramData= (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/program',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
          dispatch({type:'UNLOADING_UI'});
      
          })
}

// Course Api
export const getCourseData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/course').then(response=>{
      dispatch({type:'COURSE',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'}); 
   })
}
export const setCourseData= (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/course',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
          dispatch({type:'UNLOADING_UI'});      
         })
}

//Program_Mode APi
export const getProgramModeData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/program-mode').then(response=>{
      dispatch({type:'PROGRAM_MODE',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'}); 
   })
}
export const setProgramModeData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/program-mode',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
          dispatch({type:'UNLOADING_UI'});     
         })
}
//Program_Outcome_Type APi
export const getProgramOutcomeData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/program-outcome').then(response=>{
      console.log('test');
      dispatch({type:'PROGRAM_OUTCOME',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});   
   })
}
export const setProgramOutcomeData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/program-outcome',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
          dispatch({type:'UNLOADING_UI'});       
         })
}
//QuestionBank Api
export const getQuestionBankData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/questionbank').then(response=>{
      dispatch({type:'QUESTION_BANK',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
   })
}
export const setQuestionBankData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/questionbank',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
          dispatch({type:'UNLOADING_UI'});    
         })
}

// Course Outcome Api
export const getCourseOutcomeData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/Course-Outcome').then(response=>{
      dispatch({type:'COURSE_OUTCOME',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
   })
}
export const setCourseOutcomeData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/Course-Outcome',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
          dispatch({type:'UNLOADING_UI'});    
         })
}

// Term Api
export const getTermsData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/term').then(response=>{
      dispatch({type:'TERMS',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});   
   })
}
export const setTermsData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/term',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})   
          dispatch({type:'UNLOADING_UI'});   
         })
}


// Curriculum Api
export const getCurriculumData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/curriculum').then(response=>{
      dispatch({type:'CURRICULUM',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});   
   })
}
export const setCurriculumData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/curriculum',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
          dispatch({type:'UNLOADING_UI'});      
         })
}

// Course Curriculum Api
export const getCourseCurriculumData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/Course-Curriculum').then(response=>{
      dispatch({type:'COURSE_CURRICULUM',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
   })
}
export const setCourseCurriculumData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/Course-Curriculum',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
          dispatch({type:'UNLOADING_UI'});    
         })
}


// StackHolder Api
export const getStackholderData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/stakeholder').then(response=>{
      dispatch({type:'STACKHOLDER',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});   
   })
}
export const setStackholderData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/stakeholder',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
          dispatch({type:'UNLOADING_UI'});    
         })
}

// Survey API
export const getSurveyData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/survey').then(response=>{
      dispatch({type:'SURVEY',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});   
   })
}
export const setSurveyData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/survey',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
          dispatch({type:'UNLOADING_UI'});      
         })
}

// Template API
export const getTemplateData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/template').then(response=>{
      dispatch({type:'TEMPLATE',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});   
   })
}
export const setTemplateData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
       axios.post('/api/template',data).then(response=>{
          dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
          dispatch({type:'UNLOADING_UI'});
       }).catch(error=>{
          dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
          dispatch({type:'UNLOADING_UI'});     
         })
}


// Faculty Contribution API's


// FACULTY_WORKLOAD
export const setFacultyWorkloadData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/faculty-workload',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'});    
     })
}

export const getFacultyWorkloadData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/faculty-workload').then(response=>{
      dispatch({type:'FACULTY_WORKLOAD',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})   
      dispatch({type:'UNLOADING_UI'});
   })
}


// Research-Publication
export const setResearchPublicationData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/Research-Publication',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})   
      dispatch({type:'UNLOADING_UI'});   
     })
}

export const getResearchPublicationData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/Research-Publication').then(response=>{
      dispatch({type:'RESEARCH_PUBLICATION',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
   })
}


// /Sponsored-Projects
export const setSponsoredProjectsData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/Sponsored-Projects',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})    
      dispatch({type:'UNLOADING_UI'});  
     })
}

export const getSponsoredProjectsData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/Sponsored-Projects').then(response=>{
      dispatch({type:'SPONSORED_PROJECTS',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})   
      dispatch({type:'UNLOADING_UI'});
   })

}


// Patent-Innovation
export const setPatentInnovationData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/Patent-Innovation',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});      
     })
}

export const getPatentInnovationData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/Patent-Innovation').then(response=>{
      dispatch({type:'PATENT_INNOVATION',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});   
   })
}


// Consulting-Testing-Project
export const setConsultingTestingProjectData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/Consulting-Testing-Project',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});      
     })
}

export const getConsultingTestingProjectData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/Consulting-Testing-Project').then(response=>{
      dispatch({type:'CONSULTING_PROJECTS',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
   })
}


// award-honour
export const setawardhonourData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/award-honour',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})   
      dispatch({type:'UNLOADING_UI'});   
     })
}

export const getawardhonourData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/award-honour').then(response=>{
      dispatch({type:'AWARD_HONOUR',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});   
   })
}


// book-publish
export const setbookpublishData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/book-publish',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})   
      dispatch({type:'UNLOADING_UI'});   
     })
}

export const getbookpublishData = ()=>(dispatch)=>{
dispatch({type:'LOADING_UI'});
   axios.get('/api/book-publish').then(response=>{
      dispatch({type:'BOOK_PUBLISH',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'}); 
   })
}


// book-chapter
export const setbookchapterData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/book-chapter',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});      
     })
}

export const getbookchapterData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/book-chapter').then(response=>{
      dispatch({type:'Book_CHAPTER',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});   
   })
}


// fellow-ship
export const setfellowshipData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/fellow-ship',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});     
     })
}

export const getfellowshipData = ()=>(dispatch)=>{
dispatch({type:'LOADING_UI'});
   axios.get('/api/fellow-ship').then(response=>{
      dispatch({type:'FELLOWSHIP',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
   })
}



// workshop_organized
export const setworkshoporganizedData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/workshop_organized',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})    
      dispatch({type:'UNLOADING_UI'});  
     })
}

export const getworkshoporganizedData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/workshop_organized').then(response=>{
      dispatch({type:'WORKSHOP_ORGANIZED',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});  
   })
}


// workshop_attended
export const setworkshopattendedData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/workshop_attended',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'});    
     })
}

export const getworkshopattendedData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/workshop_attended').then(response=>{
      dispatch({type:'WORKSHOP_ATTENDED',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'}); 
   })
}


// research_projects
export const setresearchprojectsData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/research_projects',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'});    
     })
}

export const getresearchprojectsData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/research_projects').then(response=>{
      dispatch({type:'RESEARCH_PROJECTS',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});   
   })
}


// professional_bodies
export const setprofessionalbodiesData = (data)=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.post('/api/professional_bodies',data).then(response=>{
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
      dispatch({type:'UNLOADING_UI'});     
     })
}

export const getprofessionalbodiesData = ()=>(dispatch)=>{
  dispatch({type:'LOADING_UI'});
   axios.get('/api/professional_bodies').then(response=>{
      dispatch({type:'PROFESSIONAL_BODIES',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})  
      dispatch({type:'UNLOADING_UI'}); 
   })
}


// get profile APi
export const getProfileData = ()=>(dispatch)=>{
   dispatch({type:'LOADING_UI'});
   axios.get('/api/auth/profile').then(response=>{
      dispatch({type:'PROFILE_DATA',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:error?.response?.data})
      dispatch({type:'UNLOADING_UI'});
   })
}

// manageUser Api
export const getManageUser = ()=>(dispatch)=>{
   dispatch({type:'LOADING_UI'});
   axios.get('/api/auth/user-list').then(response=>{
      dispatch({type:'MANAGE_USER',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:error?.response?.data})
      dispatch({type:'UNLOADING_UI'});
   })
}

// Department wise User List
export const getDepartmentUserListData = (shortName)=>(dispatch)=>{
   dispatch({type:'LOADING_UI'});
   axios.get(`/api/department/user-list?short_name=${shortName}`).then(response=>{
      dispatch({type:'DEPARTMENT_USER_LIST',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:error?.response?.data})
      dispatch({type:'UNLOADING_UI'});
   })
}

// SEnd MAil APis
export const getSendMailData = ()=>(dispatch)=>{
   dispatch({type:'LOADING_UI'});
   axios.get('/api/send-mail').then(response=>{
      dispatch({type:'SEND_MAIL',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:error?.response?.data})
      dispatch({type:'UNLOADING_UI'});
   })
}

export const setSendMailData = (data)=>(dispatch)=>{
   dispatch({type:'LOADING_UI'});
    axios.post('/api/send-mail',data).then(response=>{
       dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
       dispatch({type:'UNLOADING_UI'});
    }).catch(error=>{
       dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}}) 
       dispatch({type:'UNLOADING_UI'});     
      })
 }

//  Manage Topic and TLOs API's
export const getManageTopicAndTloData = (data) => (dispatch) => {
   dispatch({type:'LOADING_UI'});
   axios.get('/api/Topic', data).then(response => {
      dispatch({type:'TOPIC_LIST',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:error?.response?.data})
      dispatch({type:'UNLOADING_UI'});     
     })
}

export const setManageTopicAndTloData = (data) => (dispatch) => {
   dispatch({type:'LOADING_UI'});
   axios.get('/api/Topic', data).then(response => {
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});     
     })
}

// Manage Lab Experiment List API's
export const getLabExperimentData = (data) => (dispatch) => {
   dispatch({type:'LOADING_UI'});
   axios.get('/api/lab_experiment', data).then(response => {
      dispatch({type:'LAB_EXPERIMENT_LIST',payload:response.data})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:error?.response?.data})
      dispatch({type:'UNLOADING_UI'});     
     })
}

export const setLabExperimentData = (data) => (dispatch) => {
   dispatch({type:'LOADING_UI'});
   axios.get('/api/lab_experiment', data).then(response => {
      dispatch({type:'SUCCESS_DATA',payload:{general:'successfully created'}})
      dispatch({type:'UNLOADING_UI'});
   }).catch(error=>{
      dispatch({type:'ERROR_DATA',payload:{error:error.response?.data?.errors?.detail}})
      dispatch({type:'UNLOADING_UI'});     
     })
}